import React from 'react';

import type { SalesPromotionAccountDto } from '@/services/ws-funnel/src/main/resources/rest-api';
import { getSalesPromotionAccounts } from '@/services/ws-funnel/src/main/resources/rest-api';
import type { IdSalesPromotionDto } from '@/services/ws-funnel/src/main/resources/rest-api/types';
import { useRequestLegacy } from '@/js/libs/use-request-legacy';

type PromotionAccountsState = {
  accounts: SalesPromotionAccountDto[];
  isLoading: boolean;
  reload: () => void;
};

export const usePromotionAccounts = (salesPromotionId: IdSalesPromotionDto): PromotionAccountsState => {
  const [{ items: accounts }, { pending: isLoading }, reload] = useRequestLegacy({
    apiMethod: getSalesPromotionAccounts,
    parameters: [{ salesPromotionId }],
    defaultData: { items: [], total: 0 },
  });
  return React.useMemo<PromotionAccountsState>(() => ({ accounts, isLoading, reload }), [accounts, isLoading, reload]);
};
